// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AUMU","textarea":"styles_textarea__1rfF8"};